<template>
    <!-- edit profile dialog -->
    <v-dialog
          v-model="isTranslationDialogOpen"
          max-width="720px"
          @click:outside="$emit('update:is-translation-dialog-open',false)"
        >
          <v-card class="py-8">
            <v-card-title class="justify-center text-h5 px-5">
              Let's automate some translation.
            </v-card-title>
            <v-card-text class="text-center mt-n2 px-5">
              Please fill out the below form.
            </v-card-text>
            <v-card-text class="mt-5 px-15">
              <v-form
                  ref="translationForm"
              >
                  <v-row class=" d-flex justify-space-between">
                    <v-col
                      cols="12"
                      md="6">
                    <v-radio-group
                    label="Do you want to translate..."
                    v-model="localTranslationData.translationOptions"
                  >
                    <v-radio label="Blank Portion" value="2"></v-radio>
                    <v-radio label="Entire Questionnaire" value="1"></v-radio>
                  </v-radio-group>

                </v-col>
                    <!-- <v-col
                      cols="12"
                      md="6"
                    >
                    <v-autocomplete
                        v-model="localTranslationData.from"
                        :items="languageOptions"
                        item-text="name"
                        item-value="id"
                        label="Default Language"
                        hide-detail
                        dense
                        outlined
                        return-object
                        placeholder="Select Default Language"
                        :rules="[validators.required]"
                    >
                        
                    </v-autocomplete>
                    
                    </v-col> -->
                    <v-col
                      cols="12"
                      md="6">
                    <v-autocomplete
                        v-model="localTranslationData.to"
                        :items="localTranslationData.translations"
                        item-text="name"
                        item-value="id"
                        label="Translated Language"
                        hide-detail
                        dense
                        outlined
                        return-object
                        placeholder="Translated Language"
                        class="mt-4"
                        :rules="[validators.required]"
                    >
                        
                    </v-autocomplete>
                  </v-col>
                  </v-row>
                  
                  
              </v-form>
            </v-card-text>
            
            <v-divider class="mt-0"></v-divider>
            <v-card-text class="px-15 pt-8">
              <v-btn
                    color="primary"
                    class="me-3"
                    type="submit"
                    :loading="translationLoading"
                    @click.prevent="submitTranslation"
                  >
                    Translate
                  </v-btn>
    
                  <v-btn
                    outlined
                    color="secondary"
                    @click.prevent="$emit('update:is-translation-dialog-open',false)"
                  >
                    Cancel
                  </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
  </template>
    <script>
    import { ref, watch, getCurrentInstance } from '@vue/composition-api'
    // import ProjectIntercoList from '../project-interco-list/ProjectIntercoList.vue'
    import {
      required,
    } from '@core/utils/validation'
    
    export default {
      props: {
        isTranslationDialogOpen: {
          type: Boolean,
          required: true,
        },
        projectData: {
          type: Object,
          required: true,
        },
        languageOptions: {
          type: Array,
          required: true
        },
        translationLoading: {
          type:Boolean,
          required: true
        }
      },
    
      setup(props, { emit }) {

        const vm = getCurrentInstance().proxy
        const localTranslationData = ref({})

        const submitTranslation = () => {

          
          // If step is valid proceed to the next step
          const isStepValid = vm.$refs['translationForm'].validate()
          if (isStepValid){
            const data = JSON.parse(JSON.stringify(localTranslationData.value))
            emit('translate', data)
            emit('update:is-translation-dialog-open',false)
          }
        }

        watch(
          ()=> [props.projectData.translations,
          props.projectData.language],
          () => {
            
            const tempData = JSON.parse(JSON.stringify(props.projectData))
            localTranslationData.value['from'] = tempData.language
            localTranslationData.value['translations'] = tempData.translations
            localTranslationData.value['translationOptions'] = "2" //Entire questionnaire
          }
        )

    
        return {
          localTranslationData,

          submitTranslation,

          validators: {
            required
          }
        }
      },
    }
    </script>